import { useEffect, useState, } from "react";

import { useEpisodes } from "../../../../Recoil/Novel/Episode";
import { useTitles } from "../../../../Recoil/Novel/Title";

import TitleInformation from "./Component/TitleInformation";
import EpisodeList from "./Component/EpisodeList";

import "./index.scss";
import { Button } from "@mui/material";
import LoadingCircle from "../../../../Components/LoadingCircleAnimated";
import { fn } from "../../../../Functions";

const TitleHome = ({serviceId, titleId}:{serviceId?: string, titleId?: string}) => {
    
    const { fetch: fetchTitle, titleObject } = useTitles();
    const { fetch: fetchEpisode, episodeObject } = useEpisodes();
    const [isLoading, setIsLoading] = useState(false);

    const title = titleObject[`${serviceId}:${titleId}`];
    const episodes = episodeObject[`${serviceId}:${titleId}`];

    useEffect(()=>{
        if (!serviceId || !titleId) return;
       
        fetchTitle([{serviceId, titleId}]);
        fetchEpisode({serviceId, titleId});

        setIsLoading(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[serviceId, titleId]);

    useEffect(()=>{
        if (title && episodes) {
            setIsLoading(false);
        }
    }, [title, episodes]);

    if ( !serviceId && !titleId ) {
        return <></>;
    }

    return(<div className={"TitleHomeArea"}>
        {title 
            && <TitleInformation serviceId={serviceId ?? ""} titleId={titleId ?? ""} title={title} />}
        {title && (episodes || []).length > 0
            && <EpisodeList serviceId={serviceId ?? ""} titleId={titleId ?? ""} title={title} episodes={episodes} />}
        <div className={"EpisodeNavBarBox"}>
            <Button className={"EpNavButton"} onClick={fn.gotoByAnchor} href={`/contents/${serviceId}/${titleId}/000001`} >
                {"첫화보기"}
            </Button>
        </div>
        <LoadingCircle show={isLoading} />
    </div>)
}




export default TitleHome;